import { AuthGuard } from './core/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('src/app/modules/home/home.module').then((m) => m.HomeModule)
  },
  {
    path: '',
    loadChildren: () => import('src/app/modules/sign-up/sign-up.module').then((m) => m.SignUpModule)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('src/app/modules/dashboard/dashboard.module').then((m) => m.DashboardModule)
  },
  {
    path: 'prelogin',
    loadChildren: () =>
      import('src/app/modules/pre-login/pre-login.module').then(m => m.PreLoginModule)
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
